'use client';

import { NavTourBubble } from './NavTourBubble';
import { anchorSelectorForStep } from './navTourAnchor';
import { useNavTourChromeEffects } from './useNavTourChromeEffects';
import { useNavTourCoach } from './useNavTourCoach';

/** Thin shell: coach state + chrome effects + bubble. */
export function NavTourCoach() {
  const coach = useNavTourCoach();
  useNavTourChromeEffects({
    step: coach.step,
    active: coach.active,
    stepIds: coach.stepIds,
    setStepIndex: coach.setStepIndex,
    onEscape: coach.finish,
  });

  if (!coach.active || !coach.step) return null;

  return (
    <NavTourBubble
      step={coach.step}
      stepIndex={coach.stepIndex}
      stepCount={coach.stepCount}
      onBack={coach.goBack}
      onNext={coach.goNext}
      onSkip={coach.finish}
      anchorSelector={anchorSelectorForStep(coach.step)}
    />
  );
}
